module.exports = {
	config: {
		lastMileSelector:   '.tabContents',
		open:               false,
		registerType:       'tabContentContainer',
		registerSecret:     '',
	},

	model: {
	},

	methods: {
		activate: function(){
			var hadClass = this.$.hasClass('active');
			if(!hadClass) this.triggerFind('preTabFocus');
			this.$.addClass('active');
			this.config.open = true;
			if(!hadClass) this.triggerFind('postTabFocus');
		},

		deactivate: function(){
			var hadClass = this.$.hasClass('active');
			if(hadClass) this.triggerFind('preTabBlur');
			this.$.removeClass('active');
			this.config.open = false;
			if(hadClass) this.triggerFind('postTabBlur');
		},

		close: function(restoreActiveTab){
			var self = this;
			if(self.config.registerSecret){
				self.closest('base_tabStrip_tabStrip', function(tabStripComponent){
					tabStripComponent.removeTab(self.config.registerSecret, restoreActiveTab);
				});
			}
		},

		remove: function(){
			this.destroy();
		}
	},

	hooks: {
		attach: function($element){
			if(this.config.open){
				$element.addClass('active');
			}
		}
	}
};